const FR = {
  acceptRequest: "Accepter la demande",
  accessDetail: "Détail d'accès",
  accessoryUnavailable: "Accessoire(s) indisponible(s)",
  actions: "Actions",
  activity: "Activité",
  add: "Ajouter",
  addAgency: "Ajouter une agence",
  addAgencyInfoBullet1: "Demander des devis et passer commande directement.",
  addAgencyInfoBullet2: "Bénéficier de leurs prix contrats cadres existants.",
  addAgencyInfoBullet3: "Accéder aux ressources que vous y rattacherez.",
  addAgencyInfoTitle: "En ajoutant cette agence, vos clients pourront :",
  addDocuments: "Ajouter des documents",
  addEvent: "Ajouter un événement",
  addFile: "Ajouter un fichier",
  addInformation: "Ajouter les informations",
  additionalInformation: "Informations complémentaires",
  addMessageToCustomer: "Message pour le client",
  addNewDocument: "Ajouter un nouveau document",
  addParticipant: "Ajouter un participant",
  addResource: "Ajouter une ressource",
  address: "Adresse",
  addUser: "Ajouter un utilisateur",
  agencies: "Agences",
  agency: "Agence",
  agencyArchived: "Agence archivée",
  agencyCreated: "Agence créée",
  agencyEmailDescription:
    "Toutes les notifications des commandes de l’agence (demande de devis, début de location, événement, reprise...) seront envoyées aux utilisateurs de l’agence ainsi qu’à cette adresse mail.",
  agencyIsRequired: "L'agence est requise",
  agencyName: "Nom de l'agence",
  agencyUpdated: "Agence mise à jour",
  allFilesUpToDate: "Tous les fichiers sont à jour",
  allMyOrders: "Toutes mes commandes",
  allResources: "Toutes les ressources",
  alreadyCustomer: "Déjà client ?",
  analytics: "Analytiques",
  anErrorOccurred: "Une erreur est survenue",
  apiStatus: "État de l'API",
  applicant: "Demandeur",
  applicationVersion: "Version de l'application",
  archive: "Archiver",
  archive_one: "{{count}} Archive",
  archive_other: "{{count}} Archives",
  archiveAgency: "Archiver l'agence",
  archiveAgencyConfirmation:
    "Êtes-vous sûr de vouloir archiver l'agence {{name}} ? Tous les contrats liés seront archivés et les demandes de réservation en attente seront annulées.",
  archived: "Archivée",
  areYouAConstructionCompany: "Êtes-vous une entreprise du BTP ?",
  areYouSureYouWantDetachResource: "Êtes-vous sûr·e de vouloir détacher la ressource de cette commande ?",
  areYouSureYouWantDetachUser: "Êtes-vous sûr de vouloir détacher cet utilisateur de l'agence ? Ce dernier sera notifié par e-mail.",
  areYouSureYouWantToDelete: "Êtes-vous sûr de vouloir supprimer ?",
  areYouSureYouWantToDeleteWithItem: "Êtes-vous sûr de vouloir supprimer {{item}} ?",
  articleAccess: "Accès à l'article",
  articleCategory: "Catégorie",
  articleEquipmentUpdated: "Informations de l'équipement mises à jour",
  articleInformation: {
    message: "Choisissez une machine de votre parc interne ou un opérateur",
    warningDescription: "Fournissez les documents et informations nécessaires avant la location.",
    warningTitle: "Informations de l'équipement manquantes",
  },
  articleNameIsRequired: "Le nom de l'article est requis",
  articles: "Articles",
  assignment: "Affectation",
  associatedMachine: "Machine associée",
  attachAResource: "Sélectionner une ressource",
  attachResource: "Rattacher une ressource",
  availability: "Disponibilité",
  available: "Disponible",
  backToLogin: "Retour à page de connexion",
  beginning: "Début",
  between: "entre",
  billing: "Facturation",
  billingDetailsAssociatedWithThisOrder: "Détails de la facturation associés à cette commande",
  billings: "Facturations",
  booking: {
    addAnItem: "Ajouter un article",
    automaticExtension: "Extension automatique",
    bankingHolidays: "Jours fériés",
    date: "Date",
    day: "jour",
    days: "jours",
    fromDate: "Date de début",
    saturday: "Samedi",
    sunday: "Dimanche",
    toDate: "Date de fin",
    useOn: "Utilisation :",
  },
  bookingDate: "{{fromDate}} au {{toDate}}",
  bookingEnd: "Fin de la location",
  bookingStart: "Début de la location",
  bookingStartTomorrow: "La location commence demain",
  bookingStartTomorrowMessage:
    "Veillez à ce que tout soit prêt pour la livraison en respectant les contraintes du client et en incluant les accessoires demandés le cas échéant.",
  bookings: "Locations",
  brand: "Marque",
  brandIsRequired: "La marque est requise",
  breadcrumbs: {
    booking: {
      requests: "n°{{id}}",
    },
  },
  by: "Par",
  byFile: "par fichier",
  cancel: "Annuler",
  canceled: "Annulée",
  category: "Catégorie",
  categoryName: "Nom de la catégorie",
  ceCertificate: "Certificat CE",
  changePasswordAccount: "Changer le mot de passe de votre compte Tracktor",
  chat: "Discuter",
  clickToUpload: "Cliquez pour télécharger",
  client: "Client",
  clientRequest: "Demande du client",
  clients: "Clients",
  clientWillBeNotifiedByEmail: "L’utilisateur invité sera notifié par mail.",
  close: "Fermer",
  closed: "Clôturé",
  closedAt: "Clôturé le {{date}}",
  closedAtIncidentAlert: "Clôturé le {{date}} par {{by}}",
  closeTheIncident: "Clôturer l'incident",
  code: "Code",
  codeOrKeysLocation: "Code ou l'emplacement des clés",
  commandPosts: "Postes de commande",
  company: "Entreprise",
  completed: "Terminée",
  confirm: "Confirmer",
  confirmed: "Confirmé",
  contactAction: "Contacter",
  contacts: "Contacts",
  continue: "Continuer",
  couldNotFindBookingItem: "Impossible de trouver l'article de location",
  countryCode: "Code pays",
  createAPasswordForYourAccount: "Créez un mot de passe pour votre compte",
  createNewResource: "Créer une nouvelle ressource",
  createNewUser: "Créer un nouvel utilisateur",
  createYourFirstConversation: "Créez votre première conversation",
  currentApiVersion: "Version de l'API",
  currentApiVersionUsed: "Version de l'API actuellement utilisée",
  darkMode: "Mode sombre",
  darkTheme: "Thème sombre",
  dashboard: "Tableau de bord",
  dataSheet: "Fiche technique",
  date: {
    endDate: "Date de fin",
    startDate: "Date de début",
  },
  dayCount_one: "{{count}} jour",
  dayCount_other: "{{count}} jours",
  deals: "Commandes",
  dealsView: {
    detailed: "Détaillé",
    grouped: "Groupé",
    kanban: "Vue Kanban",
    list: "Liste",
    planning: "Planning",
  },
  delete: "Supprimer",
  deleteBookingFileMessage: "Voulez-vous supprimer ce document de la commande ?",
  deleteConversation: "Supprimer la conversation",
  deleteFile: "Supprimer le fichier",
  deleteFileConfirmation: "La suppression du fichier est définitive. Êtes-vous sûr de vouloir continuer ?",
  deleteResource: "Supprimer la ressource",
  deleteResourceConfirmation:
    "La suppression d'une ressource est irréversible et supprimera tous les fichiers qui y sont liés. Êtes-vous sûr de vouloir continuer ?",
  delivery: "Livraison",
  deliveryAndReturn: "Livraison et Reprise",
  deliveryTimeConstraint: "Contrainte horaire de livraison",
  designation: "Désignation",
  detach: "Détacher",
  detachResource: "Détacher la ressource",
  detachUser: "Détacher l'utilisateur",
  detachUserSuccessfully: "Utilisateur détaché avec succès",
  document: "Document",
  documentAdded: "Document ajouté",
  documentDeleted: "Document supprimé",
  documentExp: "Doc exp.",
  documentIssue_one: "{{count}} doc à fournir",
  documentIssue_other: "{{count}} docs à fournir",
  documentIssueTooltip_one: "{{count}} document manquant ou expiré",
  documentIssueTooltip_other: "{{count}} documents manquants ou expirés",
  documentMissing_one: "{{count}} doc manq.",
  documentMissing_other: "{{count}} docs manq.",
  documentName: "Nom du document",
  documents: "Documents",
  documentsOk: "Docs OK",
  documentType: "Type de document",
  documentUpdated: "Document mis à jour",
  edit: "Modifier",
  editInfoDocument: "Modifier les informations du document",
  editMyPassword: "Modifier mon mot de passe",
  editResource: "Modifier la ressource",
  editUser: "Modifier l'utilisateur",
  email: "Email",
  emailSent: "Email envoyé",
  emailSentForgotPassword: "Un email vous a été envoyé pour réinitialiser votre mot de passe.",
  emptyBooking: "Vous n’avez aucune location à venir",
  emptyBookingMissing: "Vous n'avez aucune demandes manquées",
  emptyState: {
    noDealsFound: "Vous n'avez pas encore de commande",
    noDealsFoundDescription: "Vos nouvelles commandes apparaîtront dans ce tableau.",
    pageNotFoundDescription: "La page que vous recherchez est introuvable. Veuillez vérifier l'URL ou revenir à la page précédente.",
    returnToOrders: "Retour aux commandes",
  },
  end: "Fin",
  enterTheCode: "Entrez le code",
  enterToSend: "↵ Entrée pour envoyer · ⇧ Shift+↵ Entrée pour un retour à la ligne",
  enterYourCode: "Entrez votre code",
  enterYourMessage: "Entrez votre message",
  entity: "Entité",
  equipment: "Matériel",
  equipmentInformation: {
    maximumPlates: "Pression maximale sous la plaque de répartition (T / m2)",
    sizePlates: "Dimension des plaques de répartition (m2)",
    skid: "Descente de charge maximale au patin (T)",
  },
  equipmentNotOffered: "Matériel non proposé",
  equipments: "Matériels",
  error: {
    missingArticle: "Article manquant",
    missingDates: "Dates manquantes",
    missingQuantity: "Quantité manquante",
    missingUnitPrice: "Prix unitaire manquant",
    noBookingFound: "Aucune location trouvée",
    noClientFoundForThisRequest: "Aucun client trouvé pour cette demande",
    pleaseFillFields: "Veuillez remplir tous les champs requis",
    pleaseSelectArticleBeforeAddingNewOne: "Veuillez sélectionner un article avant d'en ajouter un nouveau",
    positiveValueOnly: "Seules les valeurs positives sont autorisées",
    resourceMustBeSelected: "Une ressource doit être sélectionnée",
    selectDates: "Veuillez sélectionner des dates valides",
    shouldBeANumber: "Doit être un nombre",
    someRequestDataAreMissing: "Certaines données de la demande sont manquantes",
    unknownError: "Erreur inconnue, veuillez réessayer",
  },
  error404: "Erreur 404",
  errorLoadingRequests: "Une erreur est survenue lors du chargement des demandes",
  escape: "Échapper",
  eventStatus: {
    accepted: "Demande de location acceptée",
    canceled: "Demande de location annulée",
    refused: "Demande de location refusée",
    sent: "Demande de location reçue",
  },
  eventUpdated: "Événement mis à jour",
  expirationDate: "Date d'expiration",
  expired: "Expiré",
  file: "le document",
  fileAddedSuccessfully: "Fichier ajouté avec succès",
  fileArchivedSuccessfully: "Fichier archivé avec succès",
  fileDeletedSuccessfully: "Fichier supprimé avec succès",
  fileHasBeenUploaded: "Le fichier a bien été téléchargé",
  fileName: "Nom du fichier",
  fileStatus: {
    expired: "Expiré",
    expires_soon: "Expire bientôt",
    up_to_date: "À jour",
  },
  files: "Fichiers",
  filesNotUpToDate: "Certains fichiers ne sont pas à jour",
  fileType: "Type de fichier",
  fileUnarchivedSuccessfully: "Fichier désarchiver avec succès",
  finish: "Terminer",
  finishDayCount: "Se termine dans {{count}} jours",
  finishToday: "Termine aujourd'hui",
  finishTomorrow: "Termine demain",
  firstName: "Prénom",
  flatRate: "Forfait",
  fleetNumber: "Numéro de parc",
  forgottenPassword: "Mot de passe oublié",
  forgottenPasswordSubtitle: "Entrez votre adresse e-mail. Nous vous enverrons un lien pour réinitialiser votre mot de passe.",
  form: {
    constraint: {
      password: "Le mot de passe doit contenir au moins 8 caractères et une majuscule",
    },
    validation: {
      required: "Ce champ est requis",
    },
  },
  generalTerms: "Conditions générales",
  getSupport: "Obtenir de l'aide",
  giveFeedback: "Faire un retour",
  globalSearchPlaceholder: "Saisissez un n° de location ou un nom d'article",
  happyToSeeYouAgain: "Heureux de vous revoir !",
  help: "Aide",
  helperText: {
    onlyImageFilesAreAllowed: "Seuls les fichiers .png, .jpeg, .pdf sont autorisés",
  },
  history: "Historique",
  home: "Accueil",
  icon: "Icône",
  identity: "Identité",
  identityCard: "Carte d'identité",
  import: "Importer",
  importFile: "Importer un fichier",
  incidentAddedSuccessfully: "Incident ajouté avec succès",
  incidentClosed: "Incident cloturé",
  incidentOpened: "Incident ouvert",
  indicateCodeOrKeysLocation: "Indiquez le code ou l'emplacement des clés",
  information: "Information",
  informations: "Informations",
  inProgress: "En cours",
  instructionManual: "Manuel d'instruction",
  insurance: "Assurance",
  internalCode: "Code interne",
  internalCodeIsRequired: "Le code interne est requis",
  invoice: "Facture",
  irreversibleAction: "Cette action est irreversible",
  key: "Clé",
  keyLocation: "Emplacement des clés",
  keys: "Clés",
  language: "Langage",
  lastName: "Nom",
  linkDocuments: "Lier les documents",
  linkDocumentsToBooking: "Documents visibles par le client",
  list: "Liste",
  logIn: "Connectez-vous",
  login: "Connexion",
  logout: "Déconnexion",
  machine: "Machine",
  machineRegistration: "Immatriculation de la machine",
  mail: "Email",
  maintenanceLog: "Carnet de maintenance",
  makeAnOffer: "Faire une offre",
  material: "Matériel",
  materialDropOffPoint: "Point de dépôt du matériel",
  messagePlaceholder: "Descente de charge maximale au patin (T), dimension des plaques de répartition (m²)…",
  messages: "Messages",
  messageToCustomer: "Message à destination du client",
  missed: "Manqués",
  missingRole: "Rôle manquant",
  modifyMyOffer: "Modifier mon offre",
  modifyOffer: "Modifier l'offre",
  myProfile: "Mon profil",
  name: "Nom",
  newConversation: "Nouvelle conversation",
  newDate: "Nouvelle date",
  newDateProposal: "Disponible à partir d’une autre date proche",
  newDocument: "Nouveau document",
  newMessage: "Nouveau message",
  newMessageCount_one: "{{count}} nouveau message",
  newMessageCount_other: "{{count}} nouveaux messages",
  newPassword: "Nouveau mot de passe",
  newPasswordConfirm: "Confirmer le nouveau mot de passe",
  newResourceCreated: "Votre nouvelle ressource a été créée ! ",
  newResourceCreatedDetails: " Enregistrer maintenant les documents et leur date de validité.",
  next: "Suivant",
  nextAssignment: "Prochaine affectation",
  no: "Non",
  noAgenciesFound: "Aucune agence trouvée",
  noAvailability: "Aucune disponibilité et déclassement impossible",
  noDocumentsFound: "Aucun document trouvé",
  noEvents: "Aucun événement",
  noFilesAttached: "Aucun fichier associé",
  noNameFound: "Aucun nom trouvé",
  noOrderFound: "Aucune commande reliée à cette article n'a été trouvée",
  notAvailable: "Indisponible",
  notes: "Notes",
  notFound: "La page que vous recherchez est introuvable.",
  notFoundRedirection: "Veuillez vérifier l'URL ou revenir à la page précédente.",
  noUsersFound: "Aucun utilisateur trouvé",
  num: "N°",
  numberOfDays: "Nombre de jours",
  numberParc: "N° de parc",
  numberParcShort: "N° parc",
  offerSendTo: "Votre offre a été envoyée à {{name}}",
  offerSendToDetails: "Vous serez averti dès que votre client approuvera votre offre.",
  onboarding: {
    featureRequests: {
      step1Description:
        "Les clients voient immédiatement sur Tracktor les fournisseurs proches de leur chantier, classés par distance et prix contrats cadre.",
      step1Title: "Augmentez vos revenus",
      step2Description:
        "Remplissez votre devis et envoyez-le. En répondant rapidement avec un prix avantageux, vous maximisez vos chances d'être sélectionné par le client !",
      step2Title: "Vous répondez en quelques clics",
    },
  },
  open: "Ouvert",
  openFullPage: "Ouvrir en pleine page",
  openFullScreen: "Ouvrir en plein écran",
  operator: "Opérateur",
  operatorDocExp: "Opér. exp.",
  operatorDocKo: "Opér. KO",
  operatorDocMissing_one: "{{count}} opér. manq.",
  operatorDocMissing_other: "{{count}} opér. manq.",
  operatorDocument: "Document de l'opérateur",
  order: "Commande",
  orderHistory: "Historique des commandes",
  orderSummary: "Récapitulatif de la commande",
  orders: "Commandes",
  other: "Autre",
  oups: "Oups !",
  overview: "Vue d'ensemble",
  pageNotFound: "Page non trouvée",
  participants: "Participants",
  password: "Mot de passe",
  passwordSetSuccessfully: "Votre mot de passe a bien été mis à jour",
  passwordsNotMatching: "Les mots de passe ne correspondent pas",
  passwordUpdated: "Votre mot de passe a bien été mis à jour",
  payments: "Paiements",
  periodicGeneralInspection: "Inspection générale périodique (VGP)",
  phone: " Téléphone",
  phoneNumber: "Numéro de téléphone",
  planning: "Planning",
  pleaseSetAPassword: "Veuillez définir un mot de passe",
  price: "Prix",
  priceExVAT: "Prix HT",
  profile: "Mon profil",
  profileUpdated: "Votre profil a bien été mis à jour",
  purchaseOrder: "Bon de commande",
  purchaseOrderNumber: "Numéro de bon de commande",
  quantity: "Quantité",
  quote: "Devis",
  reason: "Motif",
  received: "Reçue",
  refuse: "Refuser",
  refused: "Refusée",
  refusedBookingRequestMessage: "En confirmant le refus de cette demande de location, vous ne pourrez plus l’accepter par la suite.",
  refusedTheBooking: "Refuser la location",
  refuseRequest: "Refuser la demande",
  releaseNotRequested: "Le client n'a pas encore demandé la libération",
  releaseRequestedForDate: "Libération demandée pour le {{date}}",
  reload: "Recharger",
  rentalRequests: "Demandes",
  reopenTheIncident: "Rouvrir l'incident",
  replace: "Remplacer",
  request: "Demande",
  requestMissedAlert: {
    button: "Retour à mes demandes",
    description1: "Le client a envoyé cette demande à plusieurs fournisseurs et a accepté l’offre de l’un d’entre eux.",
    description2:
      "Sur Tracktor, les fournisseurs répondent en moyenne en moins d’une heure : soyez réactif pour maximiser vos chances lors des prochaines opportunités.",
    redirection: "👉 En savoir plus sur la recherche de fournisseurs sur Tracktor",
    title: "Demande manquée",
  },
  requestOfferAlertInfoDescription:
    "Répondre à chaque demande (même par un refus) augmente de 65 % vos chances d’être recontacté par ce client.",
  requestOfferAlertInfoTitle: "Ne manquez aucune opportunité",
  requestStatus: {
    expired: "Manquées",
    proposed: "Offres",
    refused: "Refusées",
    toTreat: "À traiter",
  },
  requests: "Demandes",
  requestWithID: "Demande de location n°{{id}}",
  required: "Requis",
  reservation: "Réservation",
  reservationRequestAccepted: "Demande de réservation acceptée, la commande a été créée",
  reservationRequestInfo:
    "En acceptant, cette demande sera automatiquement transformée en commande aux conditions indiquées ci-dessus. Elle apparaîtra dans vos Commandes et le client en sera informé.",
  resetInitialRequest: "Rétablir la demande initiale",
  resetPassword: "Réinitialiser le mot de passe",
  resetPrice: "Réinitialiser le prix",
  resource: "Ressource",
  resourceAddedSuccessfully: "Ressource ajoutée avec succès",
  resourceCreated: "Ressource créée",
  resourceDetachedSuccessfully: "Ressource détachée avec succès",
  resourceEmptyState: {
    button: "Ajouter votre première ressource",
    dialogContentText:
      "Ajouter plusieurs ressources en une seule fois en important un fichier (CSV, XLS, XLSX, PDF...) ou ajoutez manuellement vos ressources.",
    dialogPrimaryButton: "Ajouter manuellement",
    dialogSecondaryButton: "Importer un fichier",
    dialogSuccessContentText:
      "Ressources transférées, Le traitement de vos ressources est en cours. Elles seront bientôt disponibles dans votre espace et une confirmation vous sera envoyée par mail.",
    dialogSuccessTitle: "Ressources transférées",
    dialogTitle: "Choisissez votre méthode",
    listSubtitle1: "Ajoutez une nouvelle ressource dans votre espace",
    listSubtitle2: "Et précisez les dates de validité (VPG, CACES...)",
    listSubtitle3: "L'ensemble des documents seront transmis au client",
    listTitle1: "Enregistrez une ressource",
    listTitle2: "Ajoutez des documents",
    listTitle3: "Affectez la à une commande",
    title: "Ajoutez votre première ressource (machine, opérateur...) et simplifiez la gestion de vos commandes",
  },
  resourceName: "Nom de la ressource",
  resourcePhoto: "Photo de la ressource",
  resourcePhotoHelperText: "PNG ou JPG (max. 5 Mo)",
  resourceSearchPlaceholder: "Tapez pour rechercher (modèle, numéro de parc)",
  resources: "Ressources",
  resourceUpdated: "Ressource mise à jour",
  resourceUpdatedSuccessfully: "Ressource mise à jour avec succès",
  respondToDemand: "Répondre à la demande",
  return: "Retour",
  returnTo: "Retourner aux",
  role: "Rôle",
  save: "Enregistrer",
  saveChanges: "Enregistrer les modifications",
  search: "Recherche",
  searchContacts: "Rechercher des contacts",
  searchInApp: "Rechercher dans l'app",
  see: "Voir",
  seeDetail: "Voir le détail",
  seeOffer: "Voir l'offre",
  seeTheLines: "Voir les lignes",
  seeTheResource: "Voir la ressource",
  selectAnAgency: "Sélectionnez une agence",
  selectAnAgencyToAttachCategory: "Sélectionnez une agence pour attacher une catégorie",
  selectAnotherResource: "Sélectionner une autre ressource",
  selectDocumentType: "Sélectionner le type de document",
  selectExpirationDate: "Sélectionner la date d'expiration",
  selectResource: "Sélectionnez une ressource",
  selectResourceWarning:
    "En sélectionnant cette ressource, vous confirmez qu'elle répond aux besoins du client. Votre client sera notifié par e-mail.",
  send: "Envoyer",
  sendOffer: "Envoyer l'offre",
  sent: "Envoyé",
  serialNumber: "N° de série",
  service: "Service",
  settings: "Paramètres",
  siret: "SIRET / Numéro DNS",
  siretMustBe14Characters: "Le SIRET doit contenir exactement 14 caractères",
  sorenAnnouncement: {
    badge: "Bientôt Soren",
    badgeSwitched: "Désormais Soren",
    badgeSwitchedTooltip: "Tracktor est devenu Soren — en savoir plus",
    badgeTooltip: "Tracktor devient Soren — en savoir plus",
    gotIt: "Compris",
    readArticle: "Lire l'annonce",
    story: {
      goToCard: "Carte {{count}}",
      nextCard: "Carte suivante",
      previousCard: "Carte précédente",
      switchTitle: "Tracktor change de nom d'ici le {{date}}.",
      switchTitlePast: "Tracktor a changé de nom le {{date}}.",
      switchTitleToday: "Tracktor change de nom aujourd'hui.",
      thanksBody: "Pour vos machines, vos équipes et votre confiance.",
      thanksBodyOrders_one: "{{number}} commande ensemble. Pour vos machines, vos équipes et votre confiance.",
      thanksBodyOrders_other: "{{number}} commandes ensemble. Pour vos machines, vos équipes et votre confiance.",
      thanksTitle: "Merci, {{name}}.",
      thanksTitleAnonymous: "Merci.",
    },
    unchanged: {
      accessTitle: "Mêmes accès",
      contactsTitle: "Mêmes interlocuteurs",
      ordersTitle: "Mêmes commandes et clients",
      title: "Rien ne change à part le nom et le logo.",
    },
  },
  startDayCount: "Commence dans {{count}} jours",
  startToday: "Commence aujourd'hui",
  startTomorrow: "Commence demain",
  status: "Statut",
  supplier: "Fournisseur",
  supplierComment: "Commentaire du fournisseur",
  theBookingRequestHasBeenAccepted: "Votre offre a bien été envoyée",
  theBookingRequestHasBeenRefused: "La demande de location a été refusée",
  to: "À",
  to_add: "À ajouter",
  toAdd: "À ajouter",
  toCome: "À venir",
  toDo: "À faire",
  today: "Aujourd'hui",
  tokenVerification: "Vérification du token",
  total: "Total",
  totalHT: "Total HT",
  toUpdate: "Mettre à jour",
  type: "Type",
  typeToSearch: "Tapez pour rechercher",
  unarchive: "Désarchiver",
  units: {
    DAYS_one: "{{count}} Jour",
    DAYS_other: "{{count}} Jours",
    HOURS_one: "{{count}} Heure",
    HOURS_other: "{{count}} Heures",
    KM: "{{count}} Km",
    null: "{{count}} ",
    unit: "Unité",
    units: "Unités",
    units_one: "{{count}} Unité",
    units_other: "{{count}} Unités",
  },
  up_to_date: "À jour",

  uploadFile: "Télécharger un fichier",
  upToDate: "À jour",
  userHasBeenAttachedToAgency: "L'utilisateur a été rattaché à l'agence",
  users: "Utilisateurs",
  usersActions: {
    archiveUser: "Archiver l'utilisateur",
    archiveUserSuccessfully: "Utilisateur archivé avec succès",
    areYouSureYouWantToArchiveThisUser:
      "Êtes-vous sûr de vouloir archiver cet utilisateur ? Cet utilisateur n’aura plus accès à l’espace de l’agence et sera notifié par e-mail.",
    unarchiveUser: "Désarchiver l'utilisateur",
    unarchiveUserDescription: "En désarchivant cet utilisateur, il retrouvera l’accès à l’espace de l’agence et sera notifié par e-mail.",
    unarchiveUserSuccessfully: "Utilisateur désarchivé avec succès",
    userCreatedSuccessfully: "Utilisateur créé avec succès",
    userUpdatedSuccessfully: "Utilisateur mis à jour avec succès",
  },
  userUnarchivedSuccessfully: "Utilisateur désarchivé avec succès",
  validate: "Valider",
  worksiteAccessConstraints: "Contraintes d'accès au chantier",
  writeAMessage: "Écrire un message...",
  yes: "Oui",
  yesterday: "Hier",
  yourAccount: "Votre compte",
  yourClientWillBeNotifiedByEmail: "Votre client sera notifié par e-mail.",
  yourOffer: "Votre offre",
  yourOrdersAreWaitingForYouLogin: "Vos commandes vous attendent, connectez-vous !",
  yourResourcesWillBeAddedToYourSpaceAfterProcessing: "Vos ressources seront ajoutées à votre espace après traitement",
} as const;

export default FR;
